import { createFileRoute } from "@tanstack/react-router";

// The customer list: organisations that hold an Ecosystem Tracker account.
//
// Distinct from /organisations, which is every organisation the sector has
// whether or not they are a customer. This is the subset with an account, and
// the two answer different questions - "who is out there" against "who is
// paying us" - so they are two pages rather than a filter on one.
//
// A stub for now. Manage had one entry, Organisations, and the sector list was
// built onto it - so the accounts anyone went to Manage looking for had no
// page at all. This is that page, empty until somebody fills it.
export const Route = createFileRoute("/customers")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Customers</div>
        <div className="page-subtitle">Manage all customers</div>
      </div>
    </>
  ),
});
